var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.product)?_c('div',{staticClass:"snackbar",class:{ 'show': _vm.show }},[_c('span',{staticClass:"snackbar__label",domProps:{"innerHTML":_vm._s(`${_vm.product.name} ${_vm.$t('app.common.snackbar')}`)}}),_c('span',{staticClass:"snackbar__btn btn white",on:{"click":_vm.revertDelete}},[_vm._v(" "+_vm._s(_vm.$t('app.ctas.cancel'))+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }